<template>
  <section class="status-tabs" aria-label="Estados">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      class="status-tab"
      :class="{ active: activeTab === tab.key }"
      @click="$emit('select', tab.key)"
    >
      <span>{{ tab.label }}</span>
      <span v-if="tab.showCount">({{ tab.count }})</span>
    </button>
  </section>
</template>

<script>
export default {
  name: 'CommonStatusTabs',
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: String,
      default: 'all',
    },
  },
  emits: ['select'],
};
</script>

<style scoped>
.status-tabs {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 6px;
  border-radius: 16px;
  background: #e8edf3;
  margin-top: 14px;
}

.status-tab {
  border: 0;
  background: transparent;
  color: #465569;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 700;
}

.status-tab.active {
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
}

@media (max-width: 640px) {
  .status-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
